import { Space } from 'antd';
import { formatPayable } from '@/utils/money';
import { RoundingDeltaHint } from './RoundingDeltaHint';
import { NUMERIC_STYLE } from './numeric';

interface PayableAmountProps {
  /** `payable_amount` — whole minor units, the sum of rounded line items. */
  amount: string;
  roundingDelta: string;
  currency: string;
}

/** The invoice amount, with what the rounding cost or gained one hover away. */
export const PayableAmount = ({
  amount,
  roundingDelta,
  currency,
}: PayableAmountProps) => (
  <Space size={4} style={NUMERIC_STYLE}>
    {formatPayable(amount, currency)}
    <RoundingDeltaHint delta={roundingDelta} currency={currency} />
  </Space>
);
